<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import staticBannerCakeImgSm from "../assets/images/wedding/banner/cake-six.png?w=400&webp&imagetools";
	import staticBannerCakeImgMd from "../assets/images/wedding/banner/cake-six.png?w=432&webp&imagetools";
	import staticBannerCakeImgLg from "../assets/images/wedding/banner/cake-six.png?w=496&webp&imagetools";
	import staticBannerSliceImgSm from "../assets/images/wedding/slices/banner-slice.jpg?w=400&webp&imagetools";
	import staticBannerSliceImgMd from "../assets/images/wedding/slices/banner-slice.jpg?w=432&webp&imagetools";
	import staticBannerSliceImgLg from "../assets/images/wedding/slices/banner-slice.jpg?w=496&webp&imagetools";
	import staticBannerMinidessertsImgSm from "../assets/images/wedding/minidesserts/minidesserts.jpg?w=400&webp&imagetools";
	import staticBannerMinidessertsImgMd from "../assets/images/wedding/minidesserts/minidesserts.jpg?w=432&webp&imagetools";
	import staticBannerMinidessertsImgLg from "../assets/images/wedding/minidesserts/minidesserts.jpg?w=496&webp&imagetools";
	import staticBannerMacronsImgSm from "../assets/images/wedding/macrons/macrons.jpg?w=400&webp&imagetools";
	import staticBannerMacronsImgMd from "../assets/images/wedding/macrons/macrons.jpg?w=432&webp&imagetools";
	import staticBannerMacronsImgLg from "../assets/images/wedding/macrons/macrons.jpg?w=496&webp&imagetools";
	import staticBannerDeliveryImgSm from "../assets/images/wedding/delivery.jpg?w=400&webp&imagetools";
	import staticBannerDeliveryImgMd from "../assets/images/wedding/delivery.jpg?w=432&webp&imagetools";
	import staticBannerDeliveryImgLg from "../assets/images/wedding/delivery.jpg?w=496&webp&imagetools";
	import HowItWorks from "../components/HowItWorks.svelte";
	import WeddingsBanner from "../components/Wedding/WeddingsBanner.svelte";
	import Banner from "../components/Banner.svelte";
	import bezlaktozaIcon from "../../../core/assets/icons/bezlaktoza-icon.svg";
	import bezlepekIcon from "../../../core/assets/icons/bezlepek-icon.svg";
	import bezlepekIBezlaktozaIcon from "../../../core/assets/icons/bezlaktoza+bezlepek-icon.svg";
	import calendarDays from "../../../core/assets/icons/calendar-days.svg?raw";
	import boxOfCakes from "../../../core/assets/icons/box-of-cakes.svg?raw";
	import phoneOrder from "../../../core/assets/icons/phone-order.svg?raw";
	import cakeSize01 from "../assets/images/wedding/cakesizes/size01.png?w=246&webp&imagetools";
	import cakeSize02 from "../assets/images/wedding/cakesizes/size02.png?w=246&webp&imagetools";
	import cakeSize03 from "../assets/images/wedding/cakesizes/size03.png?w=246&webp&imagetools";
	import cakeSize04 from "../assets/images/wedding/cakesizes/size04.png?w=246&webp&imagetools";
	import cakeSize05 from "../assets/images/wedding/cakesizes/size05.png?w=246&webp&imagetools";
	import cakeSize06 from "../assets/images/wedding/cakesizes/size06.png?w=246&webp&imagetools";
	import cakeSize07 from "../assets/images/wedding/cakesizes/size07.png?w=246&webp&imagetools";
	import cakeSize08 from "../assets/images/wedding/cakesizes/size08.png?w=246&webp&imagetools";
	import cakeSize09 from "../assets/images/wedding/cakesizes/size09.png?w=246&webp&imagetools";
	import cakeSize10 from "../assets/images/wedding/cakesizes/size10.png?w=246&webp&imagetools";
	import cakeSize11 from "../assets/images/wedding/cakesizes/size11.png?w=246&webp&imagetools";
	import cakeFiveImg from "../assets/images/wedding/banner/cake-five.png?w=288&webp&imagetools";
	import cakeFourImg from "../assets/images/wedding/banner/cake-four.png?w=288&webp&imagetools";
	import cakeThreeImg from "../assets/images/wedding/banner/cake-three.png?w=288&webp&imagetools";
	import cakeTwoImg from "../assets/images/wedding/banner/cake-two.png?w=288&webp&imagetools";
	import sliceOneImg from "../assets/images/wedding/slices/slice-one.jpg?w=288&webp&imagetools";
	import sliceTwoImg from "../assets/images/wedding/slices/slice-two.jpg?w=288&webp&imagetools";
	import sliceThreeImg from "../assets/images/wedding/slices/slice-three.jpg?w=288&webp&imagetools";
	import sliceFourImg from "../assets/images/wedding/slices/slice-four.jpg?w=288&webp&imagetools";
	import sliceFiveImg from "../assets/images/wedding/slices/slice-five.jpg?w=288&webp&imagetools";
	import sliceSixImg from "../assets/images/wedding/slices/slice-six.jpg?w=288&webp&imagetools";
	import sliceSevenImg from "../assets/images/wedding/slices/slice-seven.jpg?w=288&webp&imagetools";
	import sliceEightImg from "../assets/images/wedding/slices/slice-eight.jpg?w=288&webp&imagetools";
	import sliceNineImg from "../assets/images/wedding/slices/slice-nine.jpg?w=288&webp&imagetools";
	import sliceTenImg from "../assets/images/wedding/slices/slice-ten.jpg?w=288&webp&imagetools";
	import sliceElevenImg from "../assets/images/wedding/slices/slice-eleven.jpg?w=288&webp&imagetools";
	import sliceTwelveImg from "../assets/images/wedding/slices/slice-twelve.jpg?w=288&webp&imagetools";
	import sliceThirteenImg from "../assets/images/wedding/slices/slice-thirteen.jpg?w=288&webp&imagetools";
	import sliceFourteenImg from "../assets/images/wedding/slices/slice-fourteen.jpg?w=288&webp&imagetools";
	import sliceFifteenImg from "../assets/images/wedding/slices/slice-fifteen.jpg?w=288&webp&imagetools";
	import sliceSixteenImg from "../assets/images/wedding/slices/slice-sixteen.jpg?w=288&webp&imagetools";
	import sliceSeventeenImg from "../assets/images/wedding/slices/slice-seventeen.jpg?w=288&webp&imagetools";
	import nakedImg from "../assets/images/wedding/decoration/naked.png?w=288&webp&imagetools";
	import halfNakedImg from "../assets/images/wedding/decoration/half-naked.png?w=288&webp&imagetools";
	import creamedImg from "../assets/images/wedding/decoration/creamed.png?w=288&webp&imagetools";
	import birchImg from "../assets/images/wedding/decoration/birch.png?w=288&webp&imagetools";
	import fruitOneImg from "../assets/images/wedding/decoration/fruit/fruit-one.png?w=157&webp&imagetools";
	import fruitTwoImg from "../assets/images/wedding/decoration/fruit/fruit-two.png?w=157&webp&imagetools";
	import fruitThreeImg from "../assets/images/wedding/decoration/fruit/fruit-three.png?w=157&webp&imagetools";
	import figureOneImg from "../assets/images/wedding/decoration/figures/figure-one.png?w=157&webp&imagetools";
	import figureTwoImg from "../assets/images/wedding/decoration/figures/figure-two.png?w=157&webp&imagetools";
	import figureThreeImg from "../assets/images/wedding/decoration/figures/figure-three.png?w=157&webp&imagetools";
	import flowerOneImg from "../assets/images/wedding/decoration/flowers/flower-one.png?w=157&webp&imagetools";
	import flowerTwoImg from "../assets/images/wedding/decoration/flowers/flower-two.png?w=157&webp&imagetools";
	import flowerThreeImg from "../assets/images/wedding/decoration/flowers/flower-three.png?w=157&webp&imagetools";
	import plugOneImg from "../assets/images/wedding/decoration/plugs/plug-one.png?w=157&webp&imagetools";
	import plugTwoImg from "../assets/images/wedding/decoration/plugs/plug-two.png?w=157&webp&imagetools";
	import plugThreeImg from "../assets/images/wedding/decoration/plugs/plug-three.png?w=157&webp&imagetools";
	import cakesImg from "../assets/images/wedding/alternatives/cakes.jpg?w=496&h=496&webp&imagetools";
	import dessertsImg from "../assets/images/wedding/alternatives/desserts.jpg?w=496&h=496&webp&imagetools";
	import minidessertOneImg from "../assets/images/wedding/minidesserts/minidessert-one.jpg?w=288&webp&imagetools";
	import minidessertTwoImg from "../assets/images/wedding/minidesserts/minidessert-two.jpg?w=288&webp&imagetools";
	import minidessertThreeImg from "../assets/images/wedding/minidesserts/minidessert-three.jpg?w=288&webp&imagetools";
	import minidessertFourImg from "../assets/images/wedding/minidesserts/minidessert-four.jpg?w=288&webp&imagetools";
	import minidessertFiveImg from "../assets/images/wedding/minidesserts/minidessert-five.jpg?w=288&webp&imagetools";
	import minidessertSixImg from "../assets/images/wedding/minidesserts/minidessert-six.jpg?w=288&webp&imagetools";
	import minidessertSevenImg from "../assets/images/wedding/minidesserts/minidessert-seven.jpg?w=288&webp&imagetools";
	import minidessertNineImg from "../assets/images/wedding/minidesserts/minidessert-nine.jpg?w=288&webp&imagetools";
	import minidessertTenImg from "../assets/images/wedding/minidesserts/minidessert-ten.jpg?w=288&webp&imagetools";
	import minidessertElevenImg from "../assets/images/wedding/minidesserts/minidessert-eleven.jpg?w=288&webp&imagetools";
	import minidessertTwelveImg from "../assets/images/wedding/minidesserts/minidessert-twelve.jpg?w=288&webp&imagetools";
	import minidessertFourteenImg from "../assets/images/wedding/minidesserts/minidessert-fourteen.jpg?w=288&webp&imagetools";
	import minidessertFifteenImg from "../assets/images/wedding/minidesserts/minidessert-fifteen.jpg?w=288&webp&imagetools";
	import minidessertSixteenImg from "../assets/images/wedding/minidesserts/minidessert-sixteen.jpg?w=288&webp&imagetools";
	import minidessertSeventeenImg from "../assets/images/wedding/minidesserts/minidessert-seventeen.jpg?w=288&webp&imagetools";
	import minidessertEighteenImg from "../assets/images/wedding/minidesserts/minidessert-eighteen.jpg?w=288&webp&imagetools";
	import minidessertNineteenImg from "../assets/images/wedding/minidesserts/minidessert-nineteen.jpg?w=288&webp&imagetools";
	import minidessertTwentyImg from "../assets/images/wedding/minidesserts/minidessert-twenty.jpg?w=288&webp&imagetools";
	import minidessertTwentyOneImg from "../assets/images/wedding/minidesserts/minidessert-twenty-one.jpg?w=288&webp&imagetools";
	import minidessertTwentyTwoImg from "../assets/images/wedding/minidesserts/minidessert-twenty-two.jpg?w=288&webp&imagetools";
	import minidessertTwentyThreeImg from "../assets/images/wedding/minidesserts/minidessert-twenty-three.jpg?w=288&webp&imagetools";
	import minidessertTwentyFourImg from "../assets/images/wedding/minidesserts/minidessert-twenty-four.jpg?w=288&webp&imagetools";
	import minidessertTwentyFiveImg from "../assets/images/wedding/minidesserts/minidessert-twenty-five.jpg?w=288&webp&imagetools";
	import type { AllergiesProps, CakeProps, SizeProps, WeddingCardProps } from "./WeddingsProps.js";
	import WeddingCard from "../components/Wedding/WeddingCard.svelte";
	import WeddingCakeDecorationCard from "../components/Wedding/WeddingCakeDecorationCard.svelte";
	import Allergies from "../components/Allergies.svelte";
	import { nbspify } from "../../../core/utils/nbspify";
	import WeddingCakeOrderForm from "../components/Wedding/WeddingCakeOrderForm.svelte";
	import CallToActionPanel from "../components/CallToActionPanel.svelte";
	import { weddingsCakeEnquiryPathMap } from "../../../core/schema/paths/weddingsPathMap";
	import { getGlobalSettings } from "../getGlobalSettings";
	import { writable } from "svelte/store";
	import { inViewport } from "../utils/inViewport.js";
	import WeddingCakeCardLg from "../components/Wedding/WeddingCakeCardLg.svelte";
	import WeddingCakeCardInfo from "../components/Wedding/WeddingCakeCardInfo.svelte";
	import WeddingCakeCardSm from "../components/Wedding/WeddingCakeCardSm.svelte";
	import type { Step } from "../../../core/schema/Step";
	import Slider from "../components/Slider.svelte";
	import { formatPrice } from "../../../core/utils/formatPrice";
	import { weddingCakePrices } from "../../../core/schema/weddingCakePrices";
	import { WeddingCakeSize as CakeSize } from "../../../core/schema/WeddingCakeSize";
	import { WeddingCakeDecorationStyle as DecorationStyle } from "../../../core/schema/WeddingCakeDecorationStyle";

	const { TENANT_LOCALE } = getGlobalSettings();

	const cakes: CakeProps[] = [
		{
			desc: ["3 patrový dort – ovocný světlý", "krémovaný – 50 porcí"],
			image: cakeTwoImg,
		},
		{
			desc: ["3 patrový dort – malinový ", "se šlehačkou – polonahý – 50 porcí"],
			image: cakeThreeImg,
		},
		{
			desc: ["3 patrový dort – malinový čokoládový", "nahý – 60 porcí"],
			image: cakeFourImg,
		},
		{
			desc: ["3 patrový dort – ovocný tmavý", "polonahý – 50 porcí"],
			image: cakeFiveImg,
		},
	];

	const steps: Step[] = [
		{
			title: "Poptáte termín na výrobu sladkého pohoštění",
			description:
				"Nejdříve musíme zjistit, zda máme ve vašem termínu svatby volno jak pro dort, tak i pro případnou dopravu.",
			icon: calendarDays,
		},
		{
			title: "Připravíme vám ochutnávku náplní",
			description: "Tu si vyzvednete v jedné z našich cukráren a doma v klidu všechny chutě porovnáte.",
			icon: boxOfCakes,
		},
		{
			title: "Zavoláme si a doladíme veškeré detaily",
			description:
				"Jakmile budete vědět z čeho si dort chcete poskládat a jak by měl vypadat, zavoláme si a dokončíme objednávku.",
			icon: phoneOrder,
		},
	];

	function priceFn(size: CakeSize, style: DecorationStyle): string {
		const price = weddingCakePrices[size][style];
		return price !== undefined ? formatPrice(price, TENANT_LOCALE, false) : "-";
	}

	const cakeSizeOptions: SizeProps[] = [
		{
			portions: "12",
			height: "15",
			pad: "30",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions12, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions12, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions12, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions12, DecorationStyle.Birch)}`,
			},
			image: cakeSize01,
		},
		{
			portions: "18",
			height: "15",
			pad: "30",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions18, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions18, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions18, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions18, DecorationStyle.Birch)}`,
			},
			image: cakeSize02,
		},
		{
			portions: "25",
			height: "30",
			pad: "30",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions25, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions25, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions25, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions25, DecorationStyle.Birch)}`,
			},
			image: cakeSize03,
		},
		{
			portions: "30",
			height: "30",
			pad: "30",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions30, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions30, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions30, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions30, DecorationStyle.Birch)}`,
			},
			image: cakeSize04,
		},
		{
			portions: "40",
			height: "30",
			pad: "35",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions40, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions40, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions40, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions40, DecorationStyle.Birch)}`,
			},
			image: cakeSize05,
		},
		{
			portions: "50",
			height: "30",
			pad: "40",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions50Double, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions50Double, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions50Double, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions50Double, DecorationStyle.Birch)}`,
			},
			image: cakeSize06,
			desc: "* dort má oproti třípatrovému poníženou cenu, jelikož je rychlejší na výrobu",
		},
		{
			portions: "50",
			height: "50",
			pad: "45",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions50Triple, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions50Triple, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions50Triple, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions50Triple, DecorationStyle.Birch)}`,
			},
			image: cakeSize07,
		},
		{
			portions: "60",
			height: "50",
			pad: "45",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions60, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions60, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions60, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions60, DecorationStyle.Birch)}`,
			},
			image: cakeSize08,
		},
		{
			portions: "70",
			height: "50",
			pad: "50",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions70, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions70, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions70, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions70, DecorationStyle.Birch)}`,
			},
			image: cakeSize09,
		},
		{
			portions: "80",
			height: "50",
			pad: "50",
			variants: {
				[DecorationStyle.Naked]: priceFn(CakeSize.Portions80, DecorationStyle.Naked),
				[DecorationStyle.HalfNaked]: priceFn(CakeSize.Portions80, DecorationStyle.HalfNaked),
				[DecorationStyle.Creamed]: priceFn(CakeSize.Portions80, DecorationStyle.Creamed),
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions80, DecorationStyle.Birch)}`,
			},
			image: cakeSize10,
		},
		{
			portions: "90 a více",
			variants: {
				[DecorationStyle.Naked]: `od ${priceFn(CakeSize.Portions90, DecorationStyle.Naked)}`,
				[DecorationStyle.HalfNaked]: `od ${priceFn(CakeSize.Portions90, DecorationStyle.HalfNaked)}`,
				[DecorationStyle.Creamed]: `od ${priceFn(CakeSize.Portions90, DecorationStyle.Creamed)}`,
				[DecorationStyle.Birch]: `od ${priceFn(CakeSize.Portions90, DecorationStyle.Birch)}`,
			},
			image: cakeSize11,
		},
	];

	const fillings: CakeProps[] = [
		{
			desc: ["ovocný - světlý"],
			image: sliceOneImg,
		},
		{
			desc: ["ovocný - tmavý"],
			image: sliceTwoImg,
		},
		{
			desc: ["malinový se šlehačkou"],
			image: sliceThreeImg,
		},
		{
			desc: ["borůvkový se šlehačkou"],
			image: sliceFourImg,
		},
		{
			desc: ["citronový s malinami"],
			image: sliceFiveImg,
		},
		{
			desc: ["citronový s borůvkami"],
			image: sliceSixImg,
		},
		{
			desc: ["čokoládový s malinami"],
			image: sliceSevenImg,
		},
		{
			desc: ["čokoládový s jahodami"],
			image: sliceEightImg,
		},
		{
			desc: ["čokoládový s banánem"],
			image: sliceNineImg,
		},
		{
			desc: ["čoko. se slaným karamelem"],
			image: sliceTenImg,
		},
		{
			desc: ["Schwarzwald"],
			image: sliceElevenImg,
		},
		{
			desc: ["harlekýn"],
			image: sliceTwelveImg,
		},
		{
			desc: ["Bueno"],
			image: sliceThirteenImg,
		},
		{
			desc: ["arašídový"],
			image: sliceFourteenImg,
		},
		{
			desc: ["mrkvový"],
			image: sliceFifteenImg,
		},
		{
			desc: ["Red Velvet"],
			image: sliceSixteenImg,
		},
		{
			desc: ["Pistáciový s malinami"],
			image: sliceSeventeenImg,
		},
	];

	const decorations: CakeProps[] = [
		{
			name: "nahý",
			desc: [
				"Nahá varianta je asi ten nejrustikálnější vzhled, který umíme :) Pokud do takového dortu zvolíte čokoládový krém, schováme ho za vrstvu bílého, aby byl vzhled ucelený.",
			],
			image: nakedImg,
			urlSlug: "https://cz.pinterest.com/sladkadilna/nah%C3%A9-svatebn%C3%AD-dorty/",
		},
		{
			name: "polonahý",
			desc: [
				"Polonaháč je takový elegantnější bráška naháče. Můžete si navolit více nebo méně zamazaný. Zde opět platí, že snese čokoládovou náplň.",
			],
			image: halfNakedImg,
			urlSlug: "https://cz.pinterest.com/sladkadilna/polonah%c3%a9-svatebn%c3%ad-dorty/",
		},
		{
			name: "krémovaný",
			desc: [
				"Krémovaný elegán je na pohled k nerozeznání od potahovaného dortu. Na chuti to však poznáte ihned, obmaz ze smetanového sýra je lehčí a více tak vyniká samotná náplň.",
			],
			image: creamedImg,
			urlSlug: "https://cz.pinterest.com/sladkadilna/kr%c3%a9movan%c3%a9-svatebn%c3%ad-dorty/",
		},
		{
			name: "bříza",
			desc: [
				"Dort ve stylu břízy obmazáváme jiným, o něco sladším krémem, abychom na něj mohli malovat. Do této cenové relace spadá i barevný krémovaný dort.",
			],
			image: birchImg,
			urlSlug: "https://cz.pinterest.com/sladkadilna/b%c5%99%c3%adza-svatebn%c3%ad-dorty/",
		},
	];

	const weddingCardsDecorations: WeddingCardProps[] = [
		{
			heading: "Ovoce",
			images: [fruitOneImg, fruitTwoImg, fruitThreeImg],
			alt: "Fotografie – ukázka svatebního dortu s ovocem",
			descs: ["Ovoce můžeme naskládat, co se ho vejde a nebo dort ozdobit jen tak decentně malými 'ostrůvky'."],
		},
		{
			heading: "Figurky",
			images: [figureOneImg, figureTwoImg, figureThreeImg],
			alt: "Fotografie – ukázka svatebního dortu s figurkami",
			descs: [
				"Postavičky vyrábíme z bezlepkové cukrové hmoty Smartflex Velvet. Cena za jednodušší zvíře je od 450 Kč, lidské stylizované postavy začínají na 900 Kč.",
			],
		},
		{
			heading: "Květiny",
			images: [flowerOneImg, flowerTwoImg, flowerThreeImg],
			alt: "Fotografie – ukázka svatebního dortu s květinami",
			descs: [
				"Doporučujeme zvolit takové květiny, kterými budete zdobit i celou vaši svatbu, dort do ní tak perfektně zapadne. Květinovou ozdobu od vašeho floristy/floristky nám můžete přinést den před svatbou do cukrárny a nebo nám pošlete ilustrační obrázek nevěstiny svatební kytice a my vše obstaráme za vás.",
			],
		},
		{
			heading: "Zápichy",
			images: [plugOneImg, plugTwoImg, plugThreeImg],
			alt: "Fotografie – ukázka svatebního dortu se zápichy",
			descs: [
				"Další možností, jak doplnit svatební dort, je personalizovaný dřevěný zápich v naturální barvě. Cena je 480 Kč. Můžeme nechat vyrobit vaše budoucnu společné příjmení, křestní jména a podobně.",
			],
		},
	];

	const weddingCardsAlternatives: WeddingCardProps[] = [
		{
			heading: "Naše klasické dorty jako svatební",
			images: [cakesImg],
			alt: "Fotografie – ukázka svatebního dortu s ovocem",
			descs: ["Žádný problém! Mrkněte na naše dorty a vyberte si. Jejich nespornou výhodou je velmi snadné krájení."],
		},
		{
			heading: "Zákusky jako svatební dort",
			images: [dessertsImg],
			alt: "Fotografie – ukázka svatebního dortu s figurkami",
			descs: [
				"Chcete dát prostor hostům, aby se obsloužili sami podle svých chuťových preferencí? V tom případě jsou naše nahé porcové dortíky skvělá volba. Můžeme vám k nim zapůjčit pětipatrový plastový etažér, kdy na horní patro umístíme jeden malý dort k symbolickému rozkrojení. Win-win",
			],
		},
	];

	const minidesserts: CakeProps[] = [
		{
			desc: ["mini Pavlova"],
			image: minidessertOneImg,
		},
		{
			desc: ["mini věneček"],
			image: minidessertTwoImg,
		},
		{
			desc: ["mini kremrole"],
			image: minidessertThreeImg,
		},
		{
			desc: ["mini indiánek"],
			image: minidessertFourImg,
		},
		{
			desc: ["Mascarpone košíček"],
			image: minidessertFiveImg,
		},
		{
			desc: ["mini tartaletka – slaný karamel"],
			image: minidessertSixImg,
		},
		{
			desc: ["mini tartaletka – citron"],
			image: minidessertSevenImg,
		},
		{
			desc: ["mini tartaletka – pistácie"],
			image: minidessertNineImg,
		},
		{
			desc: ["mini světlý cupcake"],
			image: minidessertTenImg,
		},
		{
			desc: ["mini čoko cupcake"],
			image: minidessertElevenImg,
		},
		{
			desc: ["mini brownies"],
			image: minidessertTwelveImg,
		},
		{
			desc: ["makronka – slaný karamel"],
			image: minidessertFourteenImg,
		},
		{
			desc: ["makronka – citron"],
			image: minidessertFifteenImg,
		},
		{
			desc: ["mini panna cotta"],
			image: minidessertSixteenImg,
		},
		{
			desc: ["mini tiramisù"],
			image: minidessertSeventeenImg,
		},
		{
			desc: ["cake pop – bílá čokoláda"],
			image: minidessertEighteenImg,
		},
		{
			desc: ["cake pop – mléčná čokoláda"],
			image: minidessertNineteenImg,
		},
		{
			desc: ["cake pop s kytičkou"],
			image: minidessertTwentyImg,
		},
		{
			desc: ["mini cheesecake – jahoda"],
			image: minidessertTwentyOneImg,
		},
		{
			desc: ["mini cheesecake – malina"],
			image: minidessertTwentyTwoImg,
		},
		{
			desc: ["mini cheesecake – borůvka"],
			image: minidessertTwentyThreeImg,
		},
		{
			desc: ["mini cheesecake – slaný karamel"],
			image: minidessertTwentyFourImg,
		},
		{
			desc: ["mini cheesecake – citron"],
			image: minidessertTwentyFiveImg,
		},
	];

	const allergies: AllergiesProps[] = [
		{
			title: "Bez lepku",
			description: "Přidá k ceně dortu nebo zákusků 10 %. Prosím, počítejte s možnými stopami lepku.",
			icon: bezlepekIcon,
		},
		{
			title: "Bez laktózy",
			description:
				"Bezlaktózová úprava přidá k ceně dortu nebo zákusků 20 %. Vše vyrábíme ve stejné výrobně, počítejte tedy s možnými stopami laktózy.",
			icon: bezlaktozaIcon,
		},
		{
			title: "Bez lepku a bez laktózy",
			description: "Přidá k ceně 30 %. Všechny úpravy lze provést jak na jednom patře, tak na celém dortu.",
			icon: bezlepekIBezlaktozaIcon,
		},
	];

	const formInViewport = writable(false);
</script>

<Layout hasPanel={!$formInViewport}>
	<div class="container">
		<section>
			<WeddingsBanner buttonText="Poptat svatební dort" />
		</section>

		<section>
			<h2 class="decorative-headline !mx-0 !mb-8 !text-center lg:!mb-12">Naše oblíbené</h2>
			<Slider items={cakes}>
				{#each cakes as cake, index}
					<WeddingCakeCardLg {cake} {index} />
				{/each}
			</Slider>
		</section>

		<section class="pt-8">
			<HowItWorks headline="Jak to probíhá?" {steps} />
		</section>

		<section>
			<div class="mx-auto max-w-[45rem] text-center">
				<h3 class="h2 mb-8 lg:text-2xl">{nbspify("Sestavme společně váš vysněný svatební dort")}</h3>
				<p class="mb-6">
					<span class="font-semibold">
						{nbspify(
							"U svatebních dortů si zakládáme na tom, aby chutě byly vyvážené, dort stabilní a vzhled dokonalý.",
						)}
					</span>
					{nbspify(
						"Do všech pater (kromě horního), vkládáme dřevěné výztuže, které spolu s tvrdými podložkami chrání dort proti propadnutí - díky podložkám se dort také skvěle krájí. Středem dortu vede dlouhá dřevěná tyč.",
					)}
				</p>
				<p>
					<span class="font-semibold">{nbspify("Vždy počítejte s vyzvednutím/dovozem dortu v den svatby.")}</span>
					{nbspify("Krémované dorty bohužel nelze uchovávat přes noc, mohly by popraskat.")}
				</p>
			</div>
		</section>

		<section>
			<Banner
				headline="Velikost dortu"
				subHeadline="Kolik hostů plánujete pozvat na svatbu?"
				image={{
					alt: "Fotografie – ukázka svatebního dortu",
					sizes: { sm: staticBannerCakeImgSm, md: staticBannerCakeImgMd, lg: staticBannerCakeImgLg },
				}}
			>
				<p>
					{nbspify(
						"Níže uvedené počty porcí jsou orientační, u každé velikosti přičítáme menší rezervu. Pokud plánujete například 65 hostů, doporučujeme zvolit dort o 60 porcích. Jedna porce má přibližně 150 gramů.",
					)}
				</p>
				<p class="mt-6">
					{nbspify(
						"Ceny jsou za dort připravený k dozdobení. Uvedená maximální výška a průměr podložky vám pomohou při komunikaci se svatebním místem ohledně dostatečného prostoru v lednici. Dorty standardně dodáváme na tvrdé bílé podložce, na přání vám dort můžeme připravit i na plátu kulatiny.",
					)}
				</p>
				<p class="mt-6 font-medium">{nbspify("Jaký bude ten váš?")}</p>
			</Banner>
			<Slider items={cakeSizeOptions}>
				{#each cakeSizeOptions as cakeSizeOption}
					<WeddingCakeCardInfo {cakeSizeOption} />
				{/each}
			</Slider>
		</section>

		<section>
			<Banner
				headline="Náplň"
				subHeadline="Na výběr máte z 17 druhů nejrůznějších náplní"
				image={{
					alt: "Fotografie – ukázka svatebního dortu",
					sizes: { sm: staticBannerSliceImgSm, md: staticBannerSliceImgMd, lg: staticBannerSliceImgLg },
				}}
			>
				<p>
					{nbspify(
						"Pokud se chcete vyhnout pranici o konkrétní druh dortu, doporučujeme zvolit všechna patra stejná :) V případě, že rozmanitosti náplní neodoláte, platí pro kombinace v třípatrových a větších dortech tři jednoduchá pravidla.",
					)}
				</p>
				<ul class="mt-4">
					<li>
						<span class="whitespace-nowrap">1 - </span>{nbspify("bílý krém musí být nad čokoládovým krémem")}
					</li>
					<li>
						<span class="whitespace-nowrap">2 - </span>{nbspify("bílý korpus musí být nad čokoládovým korpusem")}
					</li>
					<li>
						<span class="whitespace-nowrap">3 - </span>{nbspify(
							"malinový / borůvkový se šlehačkou musí být vždy jako horní patro",
						)}
					</li>
				</ul>
				<p class="mt-6 font-medium">{nbspify("Vyberte si v galerii:")}</p>
			</Banner>
			<Slider items={fillings}>
				{#each fillings as item, index}
					<WeddingCakeCardSm {item} {index} />
				{/each}
			</Slider>
		</section>

		<section>
			<div class="mx-auto mb-[2.75rem] max-w-[50rem]">
				<h2 class="decorative-headline">Styl dortu</h2>
				<p class="h2 mb-8 text-center !text-lg lg:!text-xl">{nbspify("Berete se na louce nebo na zámku?")}</p>
				<p class="text-center">
					{nbspify(
						"Dorty sestavujeme a zdobíme v cukrárně před převozem. Pro inspiraci, jak svatební dorty mohou vypadat, navštivte naše nástěnky na Pinterestu:",
					)}
				</p>
			</div>
			<div class="mb-[3.75rem] flex flex-wrap justify-center gap-x-4 gap-y-10 px-2 xl:justify-between xl:gap-6">
				{#each decorations as cake, index}
					<WeddingCakeDecorationCard {cake} {index} />
				{/each}
			</div>
			<div class="narrow-container flex flex-col gap-4 sm:gap-6 lg:flex-row">
				<div class="flex basis-[calc(50%-0.75rem)] flex-col gap-6">
					{#each weddingCardsDecorations as weddingCard, index}
						{#if index < 2}
							<WeddingCard {weddingCard} />
						{/if}
					{/each}
				</div>
				<div class="flex basis-[calc(50%-0.75rem)] flex-col gap-6">
					{#each weddingCardsDecorations as weddingCard, index}
						{#if index >= 2}
							<WeddingCard {weddingCard} />
						{/if}
					{/each}
				</div>
			</div>
		</section>

		<section>
			<div class="narrow-container">
				<div class="mx-auto max-w-[52rem]">
					<h2 class="decorative-headline">Alternativy</h2>
					<p class="h2 mb-12 text-center !text-lg lg:!text-xl">
						{nbspify("Máte jinou představu?")}
						<span class="block">{nbspify("Mrkněte na tyto možnosti")}</span>
					</p>
				</div>
				<div class="flex flex-col gap-4 sm:gap-6 md:flex-row md:gap-4 lg:gap-6">
					{#each weddingCardsAlternatives as weddingCard}
						<WeddingCard
							{weddingCard}
							class={"sm:basis-[calc(50%-0.75rem)] md:basis-[calc(50%-0.5rem)] lg:basis-[calc(50%-0.75rem)]"}
						/>
					{/each}
				</div>
			</div>
		</section>

		<section>
			<Banner
				headline="Minidezerty"
				subHeadline="Váš sweet bar bude plný barev a chutí"
				image={{
					alt: "Fotografie – ukázka minidezertů",
					sizes: {
						sm: staticBannerMinidessertsImgSm,
						md: staticBannerMinidessertsImgMd,
						lg: staticBannerMinidessertsImgLg,
					},
				}}
			>
				<p>
					{nbspify(
						"Jednomu v celém tom svatebním mumraji lehce vyhládne. Mějte proto pro vaše hosty vyhrazená místa, kam si mohou kdykoli odskočit a utišit své sladké chutě.",
					)}
				</p>
				<p class="mt-6">{nbspify("Doporučujeme počítat tak dva kousky na osobu.")}</p>
			</Banner>
			<Slider items={minidesserts}>
				{#each minidesserts as item, index}
					<WeddingCakeCardSm {item} {index} />
				{/each}
			</Slider>
		</section>

		<section>
			<Banner
				headline="Makronková věž"
				subHeadline="Nezapomenutelná ozdoba a chuťový zážitek každého sladkého baru"
				image={{
					alt: "Fotografie – ukázka makronek",
					sizes: {
						sm: staticBannerMacronsImgSm,
						md: staticBannerMacronsImgMd,
						lg: staticBannerMacronsImgLg,
					},
				}}
			>
				<p>
					{nbspify(
						"Tradiční francouzské pusinky z mandlové mouky. Na povrchu křupavé, uvnitř vláčné, plněné ganáží různých druhů, přirozeně bez lepku. Poskládané do věže se stanou nezapomenutelnou ozdobou i chuťovým zážitkem každé svatební tabule.",
					)}
				</p>
				<p class="mt-6">
					{nbspify(
						"Počet makronek/počet pater je vždy na invidualní domluvě, stejně tak příchutě. Na výběr je z 5 možností (pistácie, čokoláda, malina, slaný karamel, citron).",
					)}
				</p>
			</Banner>
		</section>

		<section>
			<Allergies {allergies} />
		</section>

		<section>
			<Banner
				headline="Přeprava"
				subHeadline="Přepravu zajišťujeme pro třípatrové a větší dorty"
				image={{
					alt: "Fotografie – ukázka vozidla k přepravě dortů",
					sizes: {
						sm: staticBannerDeliveryImgSm,
						md: staticBannerDeliveryImgMd,
						lg: staticBannerDeliveryImgLg,
					},
				}}
			>
				<p>
					{nbspify(
						"Jednopatrové a dvoupatrové dorty vozí většinou snoubenci či jejich kamarádi na místo konání sami. I tak se nás však neváhejte na dopravu zeptat, budeme-li mít kapacitu, rádi vám s dovozem pomůžeme.",
					)}
				</p>
				<p class="mt-6">
					{nbspify(
						"Cenu 14 Kč/km kalkulujeme vždy z výrobny v Libni na místo konání a zpět. Pokud je místo konání vzdáleno méně než 14 km, cena dopravy je fixně 350 Kč. Sladké vozíme v hodinových oknech mezi 9. a 17. hodinou.",
					)}
				</p>
			</Banner>
		</section>

		<section>
			<h2 class="decorative-headline">Vlastní přeprava</h2>
			<div class="flex flex-col justify-center sm:flex-row sm:gap-4 lg:gap-6">
				<ul class="list basis-[calc(50%-0.75rem)]">
					<li>{nbspify("Vyzvednutí vždy osobně na pobočce v Čakovicích nebo na Petřinách")}</li>
					<li>{nbspify("Časové rozmezí, kdy vám dort můžeme vydat, je 9-18:00")}</li>
					<li>{nbspify("Dort připravíme do tvrdé kartonové krabice")}</li>
					<li>
						{nbspify("Dort převážejte pouze v kufru auta nebo na podlaze u sedadla spolujezdce, pokud je prostorná")}
					</li>
				</ul>
				<ul class="list basis-[calc(50%-0.75rem)]">
					<li>{nbspify("Nikdy dort nedávejte na sedadlo nebo na klín")}</li>
					<li>{nbspify("S dortem je třeba zacházet tak, aby se nikdy nenaklonil")}</li>
					<li>{nbspify("Jeďte plynule, brzděte pozvolna a zatáčejte v malé rychlosti")}</li>
					<li>
						{nbspify("Ničeho se nebojte, zákazníci si už v letních měsících odvezli i několik třípatrových dortů :)")}
					</li>
				</ul>
			</div>
		</section>

		<section>
			<div class="mx-auto max-w-[50rem] text-center">
				<h2 class="decorative-headline">Platba</h2>
				<p class="mb-6">
					{nbspify(
						"Po dokončení objednávky se platí rezervační poplatek ve výši 2000 Kč a nebo celá objednávka najednou, podle vašich preferencí. Doplatek je splatný zpravidla do 14 dnů před termínem dodání.",
					)}
				</p>
			</div>
		</section>
		<section class="relative" use:inViewport={{ store: formInViewport }}>
			<h2 class="decorative-headline !mb-6">Poptávka termínu</h2>
			<div id={weddingsCakeEnquiryPathMap[TENANT_LOCALE]} class="absolute top-24 md:top-20"></div>
			<p class="mb-10 text-center font-semibold">
				{nbspify("Vyplňte, prosím, tento jednoduchý formulář. Brzy se vám ozveme zpět!")}
			</p>
			<WeddingCakeOrderForm />
		</section>
	</div>

	<CallToActionPanel hide={$formInViewport} type="wedding" />
</Layout>
